module.exports = __webpack_public_path__ + "img/cloud.484654e4.svg";